import React, { useEffect, useRef, useState } from "react";

import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import OptionsDrawer from "../../../../../../../../../components/OptionsDrawer";
import Spacer from "../../../../../../../../../components/Spacer";
import Typography from "../../../../../../../../../components/Text";
import { IOptionsDrawerOption } from "../../../../../../../../Engagement/components/Card";

import css from "../Layout.module.scss";
// hooks
import { useVisualizationHeader } from "./VisualizationHeader.hooks";

interface VisualizationHeaderProps {
	options?: IOptionsDrawerOption[];
	viewingCount?: number;
	totalCount?: number;
}

export const VisualizationHeader = (props: VisualizationHeaderProps) => {
	const { options, viewingCount, totalCount } = props;

	const [isOpen, setIsOpen] = useState(false);
	const [width, setWidth] = useState(0);
	const divRef = useRef<HTMLDivElement>(null);
	const { TitleComponent, description } = useVisualizationHeader(viewingCount, totalCount, width);
	useEffect(() => {
		const observer = new ResizeObserver((entries) => {
			for (const entry of entries) {
				if (entry.target === divRef.current) {
					setWidth(entry.contentRect.width);
				}
			}
		});

		if (divRef.current) {
			observer.observe(divRef.current);
		}

		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<div ref={divRef} className={css.visualizationHeader}>
			<Spacer height={1} />
			<span>{TitleComponent}</span>
			{description ? (
				<>
					<Spacer height={1} />
					<Typography className={css.descriptionRow} size="paragraph-3" weight="regular" color="neutral-7">
						<FontAwesomeIcon size="sm" icon={faCircleInfo} />
						{description}
					</Typography>
				</>
			) : null}
			{options ? (
				<span className={css.optionsDrawer}>
					<OptionsDrawer
						openOn="bottom"
						additionalClasses={`${css.optionsButton} ${isOpen ? css.optionsDrawerOpen : ""}`}
						horizontal={true}
						options={options}
						onSelect={(option) => option.action()}
						onOpen={setIsOpen}
						optionWidth={110}
					/>
				</span>
			) : null}
		</div>
	);
};
